import Flow from "../common/Flow";
import Modal from "../common/Modal";
import ShipType from "./ShipType";
import Table from "../common/Table";
import Typography from "../common/Typography";

function FleetModal({ store }) {
  const fleet = store.state.ships;

  return (
    <Modal store={store}>
      <Flow $space={6}>
        <Typography as="h2" fontSize="2xl">Fleet</Typography>
          <Table $style="striped">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>Status</th>
                <th>Location</th>
                <th>Frame</th>
              </tr>
            </thead>
            <tbody>
              {fleet && fleet.map((ship, idx) => (
                <tr key={idx}>
                  <td className="middle">
                    <div className="gap">
                      <ShipType ship={ship} size="lg" /> {ship.symbol}
                    </div>
                  </td>
                  <td className="middle">{ship.nav.status}</td>
                  <td className="middle">{ship.nav.waypointSymbol}</td>
                  <td className="middle">{ship.frame.symbol}</td>
                </tr>
              ))}
            </tbody>
          </Table>
      </Flow>
    </Modal>
  )
}

export default FleetModal;
